// @ts-nocheck
import {  useNavigate } from 'react-router-dom';
// @mui
import { styled } from '@mui/material/styles';
import { Button, Typography, Container, Box } from '@mui/material';
import { useAppDispatch } from '../../store/hooks';
import { reset } from '../../store/state/authSlice';
// components

// ----------------------------------------------------------------------

const ContentStyle = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  minHeight: '100vh',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  padding: theme.spacing(12, 0)
}));

// ----------------------------------------------------------------------

export default function UserLogout() {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  let data = new URLSearchParams(window.location.search).get("data");
  console.log(data, "data");
  return (
    <Container>
      <ContentStyle sx={{ textAlign: 'center', alignItems: 'center' }}>
        <Typography variant="h3" paragraph>
          {data == 'sessionExpire' ? 'Session Expire' : 'Technical Error'}
        </Typography>

        <Typography sx={{ color: 'text.secondary' }}>
          {data == 'sessionExpire' ? 'Your session has been expired.' : ' We are experiencing some technical error. '}
        </Typography>


        <div className="" style={{ display: 'flex', justifyContent: 'center ', marginTop: '10px' }}>
          <span
            className=""
            style={{ color: 'blue', cursor: 'pointer' }}
            onClick={() => {
              localStorage.removeItem('login');
              dispatch(reset());
              navigate('/login');
            }}
          >
            Click here
          </span>
          &nbsp;
          <Typography sx={{ color: 'text.secondary' }}>
          to login again {data == 'sessionExpire'?"":"or try after sometime"}
        </Typography>
        </div>
      </ContentStyle>
    </Container>
  );
}
